import {
  login as performLogin,
  logout,
  changePassword as performChangePassword,
  verifyTwoFactor as performVerifyTwoFactor,
  getProfile,
} from "@/services/auth.service";

const storedUser = localStorage.getItem("user");

export const state = {
  currentUser: storedUser ? JSON.parse(storedUser) : null,
};

export const mutations = {
  SET_CURRENT_USER(state, user) {
    state.currentUser = user;
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  },
};

export const getters = {
  loggedIn(state) {
    return !!state.currentUser;
  },
};

export const actions = {
  init() {},

  async logIn({ commit }, { login, password } = {}) {
    const result = await performLogin({ login, password });
    // 2FA challenge: don't set the user yet — the login page collects a code
    // and dispatches verifyTwoFactor.
    if (result.twoFactorRequired) {
      return result;
    }
    commit("SET_CURRENT_USER", result.user);
    return result;
  },

  async verifyTwoFactor({ commit }, { challenge, code } = {}) {
    const user = await performVerifyTwoFactor({ challenge, code });
    commit("SET_CURRENT_USER", user);
    return user;
  },

  // Re-pull the profile so cached flags (permissions, two_factor_required,
  // two_factor_permissions, password_expired) stay fresh without a re-login.
  async refreshProfile({ commit }) {
    const user = await getProfile();
    commit("SET_CURRENT_USER", user);
    return user;
  },

  async logOut({ commit }) {
    await logout();
    commit("SET_CURRENT_USER", null);
    return true;
  },

  async changePassword({ commit }, payload) {
    const user = await performChangePassword(payload);
    commit("SET_CURRENT_USER", user);
    return user;
  },

  // Aliases kept so existing components calling `auth/logout` keep working.
  logout({ dispatch }) {
    return dispatch("logOut");
  },
};
